import service from '../axios'

export const articleApi = {
  // 获取文章列表
  data(params) {
    return service.get('/www/article/data', {
      params
    })
  },
  // 获取文章详情
  get(id) {
    return service.get('/www/article/get', {
      params: { id }
    })
  }
}
